<template xmlns:v-on="http://www.w3.org/1999/xhtml">
  <div id="page-content-wrapper" class="admin-content-area">
    <div class="container-fluid xyz">
      <div class="page-header-top-container" style="display:none;">
        <!-- <div class="page-name">Tickets</div> -->
        <!-- <div class="page-name">Date : {{dateTodayAvailable}}</div> -->
        <!-- <div class="page-name col-md-6 closed-tickets-label">Closed Tickets</div> -->
      </div>

      <!--page content-->
      <div class="admin-page-content">
        <!--Content Here -->
        <div class="col-12">
         <div class="tab tab2">
         <div class="cards-right page-name-right datecss"><template v-if="timeToday != ''">{{date}} | {{timeToday}} {{ampm}}<!--{{dateTodayAvailable}}--></template></div>
            <!--<button
                             type="button"
                             class="btn btn-primary pull-left btn-sm"
                             v-on:click="generateNotQueueTicket(flag = 'CustomerNotInQueue')"
                           >Generate Ticket</button>-->
            <b-tabs>
             <!--Grid View Open Tickets-->

             <b-tab title="Open Customer Numbers" active id="openTickets">

                <div class="grid-container">

                  <template v-if="ticketsAvailableFound == true">
                    <template v-for="(ticket,key) in ticketsAvailable">
                      <template v-if="ticket.ticket_closed_at == null">
                        <div :key="key" class="cards-block">
                          <template v-if="ticket.is_printed == 0">
                            <b-card tag="article" class="mb-2 custom-card-body ticket-unprinted">
                              <div class="cards-left">
                                <p class="card-text cards-page-name"><strong>{{ticket.ticket_number}}</strong></p>
                                 <!--<p class="card-text"><strong>{{ticket.ticket_generated_date_time}}</strong></p>-->
                                <timeago :datetime="ticket.ticket_generated_date_time" locale="en-US"></timeago>
                                  <!-- {{ticket.is_printed}} -->
                                <!-- <timeago :datetime="ticket.ticket_generated_date_time" :auto-update="60" locale="en-US"></timeago> -->
                                <!-- <timeago :datetime="time" :auto-update="60" locale="en-US"></timeago> -->
                              </div>
                              <!-- {{ticket.id}} -->
                              <!-- <button
                                type="button"
                                class="btn btn-success close-ticket-btn"
                                v-on:click="closeTicket($event,ticket.id,ticket.ticket_number)"
                              >Close Ticket</button> -->
                              <div class="form-group cards-right">
                                <!-- <span :id="ticket.id" v-on:click.prevent="closeTicket($event,ticket.id,ticket.ticket_number)"> -->
                                <!--<i class="fa fa-trash-o" aria-hidden="true" >-->
                                 <!-- <label class="checkbox-inline checkbox-bootstrap checkbox-lg">
                                   <input :id="ticket.id" class = "chk_undo_checked" type="checkbox" aria-hidden="true" @input="closeTicket($event,ticket.id,ticket.ticket_number)">
                                   <span class="checkbox-placeholder"></span>
                                 </label> -->
                                <!-- </span> -->
                                <label class="checkbox-inline checkbox-bootstrap checkbox-lg">
                                  <input :id="ticket.id" type="checkbox" @change="closeTicket($event,ticket.id,ticket.ticket_number)">
                                  <span class="checkbox-placeholder"></span>
                                </label>
                                <!--</i>-->
                              </div>
                            </b-card>
                          </template>
                          <template v-if="ticket.is_printed == 1">
                            <b-card tag="article" class="mb-2 custom-card-body">
                              <div class="cards-left">
                                <p class="card-text cards-page-name"><strong>{{ticket.ticket_number}}</strong></p>
                                <!-- <p class="card-text"><strong>{{ticket.ticket_generated_at}}</strong></p> -->
                                <timeago :datetime="ticket.ticket_generated_date_time" locale="en-US"></timeago>

                                <template v-if="ticket.is_user_comment != 0">
                                  <span>{{ ticket.user_comment }}</span>
                                </template>
                                <template v-else>
                                  <div class="user-comment-box">
                                    <input :id="'comment-textbox-' + ticket.id" type="text" name="user_comment" :maxlength="ticketCommentMaxLength" v-model="ticket.user_comment" v-on:keyup.enter="submitUserComment(ticket)">                                  
                                    <i :id="'comment-button-' + ticket.id" class="fa fa-arrow-right" aria-hidden="true" v-on:click="submitUserComment(ticket)"></i>
                                    <b-tooltip :target="'comment-textbox-' + ticket.id" placement="bottom" class="comment-tool-tip">
                                      <template v-if="ticket.user_comment != null">
                                        <span style="font-size:12px;">{{(ticketCommentMaxLength - ticket.user_comment.length)}}</span>
                                      </template>
                                      <template v-else>
                                        <span style="font-size:12px;">{{ ticketCommentMaxLength }}</span>
                                      </template>
                                    </b-tooltip>
                                  </div>
                                  <div class="comment-error" :id="'comment-'+ticket.id">
                                      <label>Please enter comment</label>
                                  </div>
                                  <!-- <a href="javascript:void(0)" v-on:click="moveTicketToNotAttendedCustomer($event,ticket.id,ticket.ticket_number)">Not Attended</a> -->
                                  <a href="javascript:void(0)" v-on:click="submitUserComment(ticket)">Waiting for Rep.</a>
                                </template>
                                
                                <div class="not-attended-ticket">
                                  <label class="checkbox-inline checkbox-bootstrap checkbox-lg">
                                    <input :id="'not-attended-'+ticket.id" type="checkbox" @change="moveTicketToNotAttendedCustomer($event,ticket.id,ticket.ticket_number)">
                                    <span class="checkbox-placeholder"></span>
                                  </label>
                                  <label class="not-attended-ticket-label">Not Attended</label>
                                </div>

                                <!-- {{ticket.is_printed}} -->
                                <!-- <timeago :datetime="ticket.ticket_generated_date_time" :auto-update="60" locale="en-US"></timeago> -->
                                <!-- <timeago :datetime="time" :auto-update="60" locale="en-US"></timeago> -->
                              </div>
                              <!-- {{ticket.id}} -->
                              <!-- <button
                                type="button"
                                class="btn btn-success close-ticket-btn"
                                v-on:click="closeTicket($event,ticket.id,ticket.ticket_number)"
                              >Close Ticket</button> -->
                              <div class="form-group cards-right">
                                <label class="checkbox-inline checkbox-bootstrap checkbox-lg">
                                  <input :id="ticket.id" type="checkbox" @change="closeTicket($event,ticket.id,ticket.ticket_number)">
                                  <span class="checkbox-placeholder"></span>
                                </label>
                                <!-- <label class="checkbox-inline checkbox-bootstrap checkbox-lg">
                                  <input :id="ticket.id" type="checkbox" class = "chk_undo_checked" @input="closeTicket($event,ticket.id,ticket.ticket_number)">
                                  <span class="checkbox-placeholder"></span>
                                </label> -->
                                <!--<span :id="ticket.id" v-on:click.prevent="closeTicket($event,ticket.id,ticket.ticket_number)">-->
                                  <!--<i class="fa fa-trash-o" aria-hidden="true" ></i>-->
                                <!--</span>-->
                              </div>
                            </b-card>
                          </template>
                        </div>
                      </template>
                    </template>
                  </template>
                  <template v-else>
                    <div class="page-name col-md-12">
                      No Numbers Available.
                    </div>
                  </template>  
                    
                </div>

              </b-tab>


              <!--Grid View Close Tickets-->
              <b-tab title="Closed Customer Numbers" id="Close Tickets">
                <div class="grid-container">
                  <template v-if="ticketsClosedFound == true">
                    <template v-for="(ticket,key) in ticketsClosed">
                      <template v-if="ticket.ticket_closed_at != null">
                        <div :key="key" class="cards-block">
                          <template v-if="ticket.is_printed == 0">
                            <b-card tag="article" class="mb-2 custom-card-body ticket-unprinted">
                            <div class="cards-left">
                              <p class="card-text cards-page-name"><strong>{{ticket.ticket_number}}</strong></p>
                              <!-- <p class="card-text"><strong>{{ticket.ticket_closed_at}}</strong></p> -->
                              <timeago :datetime="ticket.ticket_closed_date_time" locale="en-US"></timeago>
                              </div>
                              <!-- {{ticket.id}} -->
                              <!-- <button
                                type="button"
                                class="btn btn-danger open-ticket-btn"
                                v-on:click="reopenTicket($event,ticket.id,ticket.ticket_number)"
                              >Reopen Ticket</button> -->
                              <div class="form-group cards-right">
                                <label class="checkbox-inline checkbox-bootstrap checkbox-lg">
                                    <input :id="ticket.id" type="checkbox" @change="reopenTicket($event,ticket.id,ticket.ticket_number)">
                                    <span class="checkbox-placeholder"></span>
                                </label>
                                <!-- <label class="checkbox-inline checkbox-bootstrap checkbox-lg">
                                    <input :id="ticket.id" type="checkbox" class = "chk_undo_checked" @input="reopenTicket($event,ticket.id,ticket.ticket_number)">
                                    <span class="checkbox-placeholder"></span>
                                </label> -->
                                <!--<span :id="ticket.id" v-on:click.prevent="reopenTicket($event,ticket.id,ticket.ticket_number)">
                                    <i class="fa fa-trash-o" aria-hidden="true" ></i>
                                  </span>-->
                              </div>
                            </b-card>
                          </template>
                          <template v-if="ticket.is_printed == 1">
                            <b-card tag="article" class="mb-2 custom-card-body">
                              <div class="cards-left">
                                <p class="card-text cards-page-name"><strong>{{ticket.ticket_number}}</strong></p>
                                <!-- <p class="card-text"><strong>{{ticket.ticket_closed_at}}</strong></p> -->
                                <timeago :datetime="ticket.ticket_closed_date_time" locale="en-US"></timeago>
                                <template v-if="ticket.is_user_comment != 0">
                                  <span>{{ ticket.user_comment }}</span>
                                </template>
                              </div>
                              <!-- {{ticket.id}} -->
                              <!-- <button
                                type="button"
                                class="btn btn-danger open-ticket-btn"
                                v-on:click="reopenTicket($event,ticket.id,ticket.ticket_number)"
                              >Reopen Ticket</button> -->
                              <div class="form-group cards-right">
                                <label class="checkbox-inline checkbox-bootstrap checkbox-lg">
                                    <input :id="ticket.id" type="checkbox" @change="reopenTicket($event,ticket.id,ticket.ticket_number)">
                                    <span class="checkbox-placeholder"></span>
                                </label>
                                <!-- <label class="checkbox-inline checkbox-bootstrap checkbox-lg">
                                    <input :id="ticket.id" type="checkbox" class = "chk_undo_checked" @input="reopenTicket($event,ticket.id,ticket.ticket_number)">
                                    <span class="checkbox-placeholder"></span>
                                </label> -->
                                <!--<span :id="ticket.id" v-on:click.prevent="reopenTicket($event,ticket.id,ticket.ticket_number)">
                                    <i class="fa fa-trash-o" aria-hidden="true" ></i>
                                  </span>-->
                              </div>
                            </b-card>
                          </template>   
                        </div>
                      </template>
                    </template>
                  </template>
                  <template v-else>
                    <div class="page-name col-md-12">
                      No Numbers Available.
                    </div>
                  </template>
                
                </div> 
              </b-tab>

              <b-tab title="Customer Not Attended" id="customerNotAttended">

                <div class="grid-container">

                  <template v-if="customerNotAttendedFound == true">
                    <template v-for="(ticket,key) in customerNotAttended">
                      <!--<template v-if="ticket.ticket_closed_at == null">-->
                        <div :key="key" class="cards-block">
                          <template v-if="ticket.is_printed == 0">
                            <b-card tag="article" class="mb-2 custom-card-body ticket-unprinted">
                              <div class="cards-left">
                                <p class="card-text cards-page-name"><strong>{{ticket.ticket_number}}</strong></p>
                                <!--<p class="card-text"><strong>{{ticket.ticket_generated_date_time}}</strong></p>-->
                                <timeago :datetime="ticket.ticket_generated_date_time" locale="en-US"></timeago>
                                <!-- {{ticket.is_printed}} -->
                                <!-- <timeago :datetime="ticket.ticket_generated_date_time" :auto-update="60" locale="en-US"></timeago> -->
                                <!-- <timeago :datetime="time" :auto-update="60" locale="en-US"></timeago> -->
                              </div>
                              <!-- {{ticket.id}} -->
                              <!-- <button
                                type="button"
                                class="btn btn-success close-ticket-btn"
                                v-on:click="closeTicket($event,ticket.id,ticket.ticket_number)"
                              >Close Ticket</button> -->
                              <div class="form-group cards-right">
                                <!-- <span :id="ticket.id" v-on:click.prevent="closeTicket($event,ticket.id,ticket.ticket_number)"> -->
                                <!--<i class="fa fa-trash-o" aria-hidden="true" >-->
                                <!-- <label class="checkbox-inline checkbox-bootstrap checkbox-lg">
                                  <input :id="ticket.id" class = "chk_undo_checked" type="checkbox" aria-hidden="true" @input="closeTicket($event,ticket.id,ticket.ticket_number)">
                                  <span class="checkbox-placeholder"></span>
                                </label> -->
                                <!-- </span> -->
                                <label class="checkbox-inline checkbox-bootstrap checkbox-lg">
                                  <!--<input :id="ticket.id" type="checkbox" @change="closeTicket($event,ticket.id,ticket.ticket_number)">-->
                                  <input :id="ticket.id" type="checkbox" @change="reopenTicket($event,ticket.id,ticket.ticket_number)">
                                  <span class="checkbox-placeholder"></span>
                                </label>
                                <!--</i>-->
                              </div>
                            </b-card>
                          </template>
                          <template v-if="ticket.is_printed == 1">
                            <b-card tag="article" class="mb-2 custom-card-body">
                              <div class="cards-left">
                                <p class="card-text cards-page-name"><strong>{{ticket.ticket_number}}</strong></p>
                                <!-- <p class="card-text"><strong>{{ticket.ticket_generated_at}}</strong></p> -->
                                <timeago :datetime="ticket.ticket_generated_date_time" locale="en-US"></timeago>
                                <template v-if="ticket.is_user_comment != 0">
                                  <span>{{ ticket.user_comment }}</span>
                                </template>
                                <!--<button class="btn btn-primary" v-on:click="">Click</button>-->
                                <!-- {{ticket.is_printed}} -->
                                <!-- <timeago :datetime="ticket.ticket_generated_date_time" :auto-update="60" locale="en-US"></timeago> -->
                                <!-- <timeago :datetime="time" :auto-update="60" locale="en-US"></timeago> -->
                              </div>
                              <!-- {{ticket.id}} -->
                              <!-- <button
                                type="button"
                                class="btn btn-success close-ticket-btn"
                                v-on:click="closeTicket($event,ticket.id,ticket.ticket_number)"
                              >Close Ticket</button> -->
                              <div class="form-group cards-right">
                                <label class="checkbox-inline checkbox-bootstrap checkbox-lg">
                                  <input :id="ticket.id" type="checkbox" @change="reopenTicket($event,ticket.id,ticket.ticket_number)">
                                  <span class="checkbox-placeholder"></span>
                                </label>
                                <label class="not-attended-label">Not Attended</label>
                                <!-- <label class="checkbox-inline checkbox-bootstrap checkbox-lg">
                                  <input :id="ticket.id" type="checkbox" class = "chk_undo_checked" @input="closeTicket($event,ticket.id,ticket.ticket_number)">
                                  <span class="checkbox-placeholder"></span>
                                </label> -->
                                <!--<span :id="ticket.id" v-on:click.prevent="closeTicket($event,ticket.id,ticket.ticket_number)">-->
                                <!--<i class="fa fa-trash-o" aria-hidden="true" ></i>-->
                                <!--</span>-->
                              </div>
                            </b-card>
                          </template>
                        </div>
                      <!--</template>-->
                    </template>
                  </template>
                  <template v-else>
                    <div class="page-name col-md-12">
                      No Numbers Available.
                    </div>
                  </template>

                </div>

              </b-tab>

              <b-tab title="Not in Queue" id="openTickets">

                <div class="grid-container">

                  <template v-if="customerNotInQueueFound == true">
                    <template v-for="(ticket,key) in customerNotInQueue">
                        <div :key="key" class="cards-block">
                          <template v-if="ticket.customerNotInQueue == 'true'">
                            <b-card tag="article" class="mb-2 custom-card-body">
                              <div class="cards-left">
                                <p class="card-text cards-page-name"><strong>{{ticket.ticket_no}}</strong></p>
                                <!-- <timeago :datetime="ticket.ticket_generated_date_time" locale="en-US"></timeago> -->
                              </div>
                              <div class="form-group cards-right">
                                <label class="checkbox-inline checkbox-bootstrap checkbox-lg">
                                  <input :id="'ticket-'+key" type="checkbox" @change="closeTicket($event, '', ticket.ticket_no, flag='customerNotInQueue')">
                                  <span class="checkbox-placeholder"></span>
                                </label>
                              </div>
                            </b-card>
                          </template>
                          <template v-if="ticket.customerNotInQueue == 'false'">
                            <b-card tag="article" class="mb-2 custom-card-body ticket-unprinted">
                                <div class="cards-left">
                                  <p class="card-text cards-page-name"><strong>{{ticket.ticket_no}}</strong></p>
                                </div>
                                <div class="form-group cards-right">
                                  <label class="checkbox-inline checkbox-bootstrap checkbox-lg">
                                    <!--<input :id="ticket.id" type="checkbox" @change="closeTicket($event,ticket.id,ticket.ticket_number)">-->
                                    <span class="checkbox-placeholder"></span>
                                  </label>
                                  <!--</i>-->
                                </div>
                            </b-card>
                          </template>
                        </div>
                    </template>
                  </template>
                  <template v-else>
                    <div class="page-name col-md-12">
                      No Numbers Available.
                    </div>
                  </template>

                </div>

              </b-tab>
            </b-tabs>
          </div>
          </div>
        <!--Tab 2-->
       
      </div>
      <!--page content-->
    </div>
    <app-footer></app-footer>
  </div>
  <!-- /#page-content-wrapper -->
</template>

<script>
import Vue from "vue";
import { HTTP } from "../http-common";
import FrontFooter from "@/components/FrontFooter";
import EventBus from "./event-bus";
// import { Card } from "bootstrap-vue/es/components";
import VueTimeago from 'vue-timeago';
import moment from 'moment';
import Swal from 'sweetalert2';


Vue.use(VueTimeago, {
  name: 'Timeago', // Component name, `Timeago` by default
  locale: 'en-US', // Default locale
  autoUpdate: true,
  includeSeconds: true,
  // We use `date-fns` under the hood
  // So you can use all locales from it
  locales: {
    'en-US': require('date-fns/locale/en-US'),
    // 'ja': require('date-fns/locale/ja'),
  }
})

var self;
var intervalID = 0;
export default {
  name: "CloseTicket",
  components: {
    "app-footer": FrontFooter
  },
  data() {
    return {
      // ticket_number: "",
      // ticket_number_error_msg: "",
        ticketsAvailable: [],
        ticketsClosed: [],
        ticketsFound:true,
        ticketsAvailableFound:true,
        ticketsClosedFound:true,
        dateTodayAvailable: "",
        ticketsAvailableCount: 0,
        ticketsClosedCount: 0,
        ticketsCommentCount: 0,
        ticketsNQCount: 0,
        ticketCommentMaxLength: 40,
        userTimer: new Date(),
        dateToday: "",
        timeToday: "",
        date:"",
        hours: "",
        minutes: "",
        seconds: "",
        ampm: "",
        date_temp:'',
        customerNotInQueue : [],
        customerNotInQueueCount : 0,
        customerNotInQueueFound : true,
        customerNotAttended : [],
        customerNotAttendedFound : true,
        locationId: "",
    };
  },
    created() {
        // use the current time
        this.time = Date.now()
    },
    beforeMount: function() {
        self = this;
        self.date_temp='Friday, 12-Feb-17 15:52:01 UTC';
        //self.checkLogin();
    },
  mounted: function() {
    self = this;
    self.getTicketsAvailableByLocationAndDate();
    self.getTicketsClosedByLocationAndDate();
    self.generateNotQueueTicket();
    let userObj = JSON.parse(localStorage.getItem("user_obj"));
    if (userObj != null) {
        let locationId = JSON.parse(localStorage.getItem("user_obj")).location_id;
        self.locationId = locationId;
    }
    //self.getCustomerNotAttendedTicktes();
    
    self.initEventSource();

    EventBus.$on('toggle-location', self.toggleLocation);
  },
  beforeDestroy: function() {
    if (this.echoChannel) {
        window.Echo.leave(`tickets-update.${this.locationId}`);
    }
  },
  methods: {
      generateNotQueueTicket: function (flag) {
          var config = {
              headers: {
                  Authorization: "Bearer " + localStorage.getItem("api_token")
              }
          };

          var location_id_to_use = localStorage.getItem("current_location_view");

          let locationId = JSON.parse(localStorage.getItem('user_obj')).location_id;

          if(location_id_to_use == "will_call") {
            locationId = JSON.parse(localStorage.getItem('user_obj')).will_call_location_id;
          }

          let data = {
              location_id : locationId,
          };

          HTTP.post("/ticket/generate/cutomernotinqueue", data, config)
              .then(function(response) {
                  if (response.data.code == 200) {
                    //console.log(response.data);
                      if(typeof(response.data.content)  == "array") {
                        self.customerNotInQueue = response.data.content;
                      } else {
                        self.customerNotInQueue = Object.values(response.data.content);
                      }

                      self.ticketsNQCount = response.data.not_in_queue_numbers;
                      // console.log(self.ticketsNQCount);
                      self.customerNotInQueueCount = self.customerNotInQueue.length;
                      if(self.customerNotInQueue.length){
                          self.customerNotInQueueFound = true;
                      }else{
                          self.customerNotInQueueFound = false;
                      }
                  }
              })
              .catch(function(err) {
                  console.log(err);
                  if (err.response.status == 0) {
                      self.error = "Remote server can not be reachable";
                  } else {
                      //redirect to login page if user not authenticated
                      if (err.response.status == 401) {
                          //clear previous data
                          localStorage.removeItem("user_obj");
                          localStorage.removeItem("api_token");
                          localStorage.removeItem("profile_image");
                          //EventBus.$emit("logged-in", true, "", "");
                          self.$router.push("/login");
                      }
                      self.error = err.response.data.message;
                  }
              });
      },
      moveTicketToNotAttendedCustomer: function($event, ticket_id, ticket_number) {
          
          var config = {
              headers: {
                  Authorization: "Bearer " + localStorage.getItem("api_token")
              }
          };

          var userId = JSON.parse(localStorage.getItem("user_obj")).id;

          var data = {
              ticket_no: ticket_number,
              user_id: userId,
              id: ticket_id
          };

          self.$swal({
              title: 'Are you sure?',
              text: 'You want to move this ticket to not attended?',
              type: 'warning',
              showCancelButton: true,
              confirmButtonText: 'Yes',
              cancelButtonText: 'No!',
              showCloseButton: true,
              showLoaderOnConfirm: false
          }).then((result)=>{
              if(result.value){
                  HTTP.post("ticket/movetocustomernotattended", data, config)
                      .then(function(response) {
                          if (response.data.code == "200") {
                              $('#'+$event.target.id).prop('checked', false);
                              if (response.data.content.type == "success") {
                                  // self.sweetTimer(response.data.message, "success");
                              } else if (response.data.content.type == "info") {
                                  // self.sweetTimer(response.data.message, "info");
                              } else {
                                  // self.sweetTimer(response.data.message, "warning");
                              }
                              // $("#"+$event.target.id).prop('checked', false);
                              self.getTicketsAvailableByLocationAndDate();
                              self.getTicketsClosedByLocationAndDate();
                              //self.getCustomerNotAttendedTicktes();

                          }
                      })
                      .catch(function(err) {
                          // console.log(err);
                          if (err.response.status == 0) {
                              self.error = "Remote server can not be reachable";
                          } else {
                              //redirect to login page if user not authenticated
                              if (err.response.status == 401) {
                                  //clear previous data
                                  localStorage.removeItem("user_obj");
                                  localStorage.removeItem("api_token");
                                  localStorage.removeItem("profile_image");
                                  //EventBus.$emit("logged-in", true, "", "");
                                  self.$router.push("/login");
                              }
                              self.error = err.response.data.message;
                          }
                      });
              }else{
                  // self.$swal('Cancelled', 'Your action was canceled', 'info');
                  $('#'+$event.target.id).prop('checked', false);
              }
          })
          //   closeTicketChecked = false;
          // }else{

          // }
      },
      getCustomerNotAttendedTicktes: function() {
          var config = {
              headers: {
                  Authorization: "Bearer " + localStorage.getItem("api_token")
              }
          };

          var location_id_to_use = localStorage.getItem("current_location_view");

          var data = {
            location_id_to_use: location_id_to_use,
          };

          HTTP.post("/ticket/getnotattendedcustomertickets", data, config)
              .then(function(response) {
                  if (response.data.code == "200") {
                      self.customerNotAttended = response.data.content.ticketsAvailable;
                      // console.log("ticketsAvailableCount :: " + self.ticketsAvailableCount);
                      // self.dateTodayAvailable = response.data.content.dateToday;
                      // self.userTimer = moment(response.data.content.dateToday).format("YYYY,MM,DD,HH,mm,ss");
                      //
                      // clearInterval(intervalID);
                      // self.setDateToday(self.userTimer);

                      if(self.customerNotAttended.length){
                          self.customerNotAttendedFound = true;
                      }else{
                          self.customerNotAttendedFound = false;
                      }
                  }
              })
              .catch(function(err) {
                  console.log(err);
                  if (err.response.status == 0) {
                      self.error = "Remote server can not be reachable";
                  } else {
                      //redirect to login page if user not authenticated
                      if (err.response.status == 401) {
                          //clear previous data
                          localStorage.removeItem("user_obj");
                          localStorage.removeItem("api_token");
                          localStorage.removeItem("profile_image");
                          //EventBus.$emit("logged-in", true, "", "");
                          self.$router.push("/login");
                      }
                      self.error = err.response.data.message;
                  }
              });
      },
      initEventSource: function() {
        var self = this;

        let userLocation = JSON.parse(localStorage.getItem("user_obj")).location_id;

        if (localStorage.getItem("current_location_view") == "will_call") {
            userLocation = JSON.parse(localStorage.getItem("user_obj")).will_call_location_id;
        }

        // Avoid duplicate subscriptions
        if (window.Echo && userLocation) {
            // Leave any existing channel first (optional but safe)
            if (this.currentEchoChannel) {
                window.Echo.leave(this.currentEchoChannel);
            }

            const channelName = `tickets-update.${userLocation}`;
            this.currentEchoChannel = channelName;

            window.Echo.channel(channelName)
                .listen('.tickets.updated', (event) => {
                    // You can check event payload here
                    console.log('Event received:', event);

                    self.getTicketsAvailableByLocationAndDate();
                    self.getTicketsClosedByLocationAndDate();
                    self.generateNotQueueTicket();
                    // self.getCustomerNotAttendedTicktes();
                });
        }
    },

      isNumber: function(event) {
        var controlKeys = [8, 9, 13, 35, 36, 37, 39];
        // IE doesn't support indexOf
        var isControlKey = controlKeys.join(",").match(new RegExp(event.which));
        // Some browsers just don't raise events for control keys. Easy.
        // e.g. Safari backspace.
        if (
          !event.which || // Control keys in most browsers. e.g. Firefox tab is 0
          (48 <= event.which && event.which <= 57) || // Always 0 through 9
          isControlKey
        ) {
          // Opera assigns values for control keys.
          return;
        } else {
          event.preventDefault();
        }
      },
      closeTicket: function($event, ticket_id, ticket_number, flag) {
        
        // console.log(ticket_id);
        // console.log(ticket_number);
        //  console.log($event.target.id);
        // var closeTicketChecked = $event.target.checked;
        
        // if(closeTicketChecked == true){
          var config = {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("api_token")
            }
          };

          var userId = JSON.parse(localStorage.getItem("user_obj")).id;

          var location_id_to_use = localStorage.getItem("current_location_view");

          var data = {
            ticket_no: ticket_number,
            user_id: userId,
            id: ticket_id,
            flag : flag,
            location_id_to_use: location_id_to_use
          };
      
          self.$swal({
                title: 'Are you sure?',
                text: 'You want to close the number?',
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes',
                cancelButtonText: 'No!',
                showCloseButton: true,
                showLoaderOnConfirm: false
                }).then((result)=>{
                    if(result.value){
                        HTTP.post("ticket/close", data, config)
                        .then(function(response) {
                            if (response.data.code == "200") {

                                if (response.data.content.type == "success") {
                                    // self.sweetTimer(response.data.message, "success");
                                } else if (response.data.content.type == "info") {
                                    // self.sweetTimer(response.data.message, "info");
                                } else {
                                    // self.sweetTimer(response.data.message, "warning");
                                }
                                console.log($event.target.id);
                                $('#'+$event.target.id).prop('checked', false);
                                self.getTicketsAvailableByLocationAndDate();
                                self.getTicketsClosedByLocationAndDate();
                                self.generateNotQueueTicket();
                                //self.getCustomerNotAttendedTicktes();
                              
                            }
                            })
                            .catch(function(err) {
                              console.log(err);
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                localStorage.removeItem("profile_image");
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                                }
                                self.error = err.response.data.message;
                            }
                        });
                    }else{
                        // self.$swal('Cancelled', 'Your action was canceled', 'info');
                        $('#'+$event.target.id).prop('checked', false);
                }
            })
        //   closeTicketChecked = false; 
        // }else{
    
        // }
      },
      sweetTimer: function(message, alertType) {
        this.$swal({
          type: alertType,
          text: message,
          showConfirmButton: true,
          timer: 300000,
          confirmButtonText: "OK"
        });
      },
      getTicketsAvailableByLocationAndDate: function() {
        var config = {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("api_token")
          }
        };

        var location_id_to_use = localStorage.getItem("current_location_view");

        var data = {
          location_id_to_use: location_id_to_use,
        };
        
        HTTP.post("/ticketsbylocationanddate/available", data, config)
          .then(function(response) {
            if (response.data.code == 200) {
              self.ticketsAvailable = response.data.content.ticketsAvailable;
              self.ticketsAvailableCount = self.ticketsAvailable.length;
              // console.log("ticketsAvailableCount :: " + self.ticketsAvailableCount);
              self.dateTodayAvailable = response.data.content.dateToday;
              self.userTimer = moment(response.data.content.dateToday).format("YYYY,MM,DD,HH,mm,ss");

              clearInterval(intervalID);
              self.setDateToday(self.userTimer);

              if(self.ticketsAvailable.length){
                self.ticketsAvailableFound = true;
              }else{
                self.ticketsAvailableFound = false;
              }

              self.ticketsCommentCount = response.data.content.commentCount;
            }
          })
          .catch(function(err) {
            if (err.response.status == 0) {
              self.error = "Remote server can not be reachable";
            } else {
              //redirect to login page if user not authenticated
              if (err.response.status == 401) {
                //clear previous data
                localStorage.removeItem("user_obj");
                localStorage.removeItem("api_token");
                localStorage.removeItem("profile_image");
                //EventBus.$emit("logged-in", true, "", "");
                self.$router.push("/login");
              }
              self.error = err.response.data.message;
            }
          });
      },
      reopenTicket: function($event, ticket_id, ticket_number) {
          // console.log(ticket_id);
          // console.log(ticket_number);
          // var reopenTicketChecked = $event.target.checked;
          
          // if(reopenTicketChecked == true){
              var config = {
                headers: {
                Authorization: "Bearer " + localStorage.getItem("api_token")
                }
              };

              var userId = JSON.parse(localStorage.getItem("user_obj")).id;

              var data = {
                  ticket_no: ticket_number,
                  user_id: userId,
                  id: ticket_id
              };
              self.$swal({
                title: 'Are you sure?',
                text: 'You want to re-open the number?',
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes',
                cancelButtonText: 'No!',
                showCloseButton: true,
                showLoaderOnConfirm: false
                }).then((result)=>{
                    if(result.value){
                        HTTP.post("ticket/reopen", data, config)
                        .then(function(response) {
                            if (response.data.code == "200") {

                                if (response.data.content.type == "success") {
                                    // self.sweetTimer(response.data.message, "success");
                                } else {
                                    // self.sweetTimer(response.data.message, "info");
                                }
                                $('#'+$event.target.id).prop('checked', false);
                                self.getTicketsAvailableByLocationAndDate();
                                self.getTicketsClosedByLocationAndDate();
                                self.generateNotQueueTicket();
                                //self.getCustomerNotAttendedTicktes();
                                // reopenTicketChecked = false;
                            }
                        })
                        .catch(function(err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                localStorage.removeItem("profile_image");
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                                }
                                self.error = err.response.data.message;
                            }
                        }); 
                    }else{
                        // self.$swal('Cancelled', 'Your action was canceled', 'info');
                        $('#'+$event.target.id).prop('checked', false);
                }
            })
          //   reopenTicketChecked = false;
          // }else{

          // }
      },
      getTicketsClosedByLocationAndDate: function() {
        var config = {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("api_token")
          }
        };

        var location_id_to_use = localStorage.getItem("current_location_view");

        var data = {
          location_id_to_use: location_id_to_use,
        };
        
        HTTP.post("/ticketsbylocationanddate/closed", data, config)
          .then(function(response) {
            if (response.data.code == "200") {
              self.ticketsClosed = response.data.content.ticketsClosed;
              self.ticketsClosedCount = self.ticketsClosed.length;
              // console.log("ticketsClosedCount :: " + self.ticketsClosedCount);
              if(self.ticketsClosed.length){
                self.ticketsClosedFound = true;
              }else{
                self.ticketsClosedFound = false;
              }
            }
          })
          .catch(function(err) {
            if (err.response.status == 0) {
              self.error = "Remote server can not be reachable";
            } else {
              //redirect to login page if user not authenticated
              if (err.response.status == 401) {
                //clear previous data
                localStorage.removeItem("user_obj");
                localStorage.removeItem("api_token");
                localStorage.removeItem("profile_image");
                //EventBus.$emit("logged-in", true, "", "");
                self.$router.push("/login");
              }
              self.error = err.response.data.message;
            }
          });
      },
    //clock timer functions
      padZero: function(number) {
        if (number < 10) {
          return "0" + number;      
        }
        return number;
      },
      twelveHours: function(number) {
        if (number > 12) {
          number = number - 12;
        }
        return this.padZero(number);
      },
      getAmPm: function(hours) {
        if (hours > 12) {
          self.ampm = " PM";
        }
        else{
          self.ampm = " AM";   
        }
        return self.ampm;
      },
      setDateToday: function(date) {
        var result = date.split(',');
        /*self.dateToday = new Date();*/
        // console.log(result[1]);
        self.dateToday = new Date(result[0],result[1] - 1,result[2],result[3],result[4],result[5]);
        // self.dateToday = new Date(2019, 12, 19, 0, 0, 0);

        self.date = moment(this.padZero(self.dateToday.getFullYear()) + '-' + this.padZero(self.dateToday.getMonth() + 1) + '-' + this.padZero(self.dateToday.getDate())).format("Do MMM YYYY");
        //self.timeToday = this.padZero((self.dateToday.getHours()) + ':' + this.padZero(self.dateToday.getMinutes()) + ':' + this.padZero(self.dateToday.getSeconds()));


        var hours = self.dateToday.getHours();

        var minutes = self.dateToday.getMinutes();

        var seconds = self.dateToday.getSeconds();

        var ampm = this.getAmPm((self.dateToday.getHours()));

        this.clock(hours,minutes,seconds);
      },
      clock: function(hours,minutes,seconds) {
        var sec; 
        var min; 
        var hrs;
                  

        if(((seconds<=59) && (seconds>=0)) && ((minutes<=59) && (minutes>=0)) && ((hours<=23) && (hours>=0))){
          var self = this;
          sec = seconds;
          min = minutes;
          hrs = hours;
          intervalID = setInterval(function(){
            sec++;
            if(sec==60){sec=0;min++;}
            if(min==60){min=0;hrs++;}
            if(hrs==24){hrs = 0; min = 0; sec = 0;}

            self.timeToday = self.twelveHours(hrs) + ' : ' + self.padZero(min) + ' : ' + self.padZero(sec);
            self.ampm = self.getAmPm(hrs);

          },1000);    
        }
      },
      toggleLocation: function(current_location_view) {
        if(typeof (self) != "undefined") {
            self.ticketsClosedCount = 0;
            self.ticketsAvailableCount = 0;
            self.ticketsNQCount = 0;
            self.ticketsCommentCount = 0;

            self.ticketsClosed = [];
            self.ticketsAvailable = [];
            self.customerNotAttended = [];
            self.customerNotInQueue = [];
            self.initEventSource();
        }
        console.log("Waiting for 1 Second");
        setTimeout(function() {
          if(typeof (self) != "undefined") {
            console.log("Wait is over");
            self.getTicketsAvailableByLocationAndDate();
            self.getTicketsClosedByLocationAndDate();
            self.generateNotQueueTicket();
            //self.getCustomerNotAttendedTicktes();
          }
        }, 1000);
      },
      submitUserComment: function(ticket) {
      
        if(ticket.user_comment == null || ticket.user_comment.length == 0) {
          $("#comment-"+ticket.id).show();
          return;
        } else {
          $("#comment-"+ticket.id).hide();
        }

        $("#comment-button-"+ticket.id).removeClass('fa fa-arrow-right');
        $("#comment-button-"+ticket.id).addClass('fa fa-spinner fa-spin');
         
        var config = {
          headers: {
              Authorization: "Bearer " + localStorage.getItem("api_token")
          }
        };

        var userId = JSON.parse(localStorage.getItem("user_obj")).id;

        var data = {
            ticket_no: ticket.ticket_number,
            user_id: userId,
            id: ticket.id,
            ticket_comment: ticket.user_comment,
        };

        HTTP.post("/ticket/addusercomment", data, config)
          .then(function(response) {
              if (response.data.code == 200) {
                //$("#comment-button-"+ticket.id).removeClass('fa fa-spinner fa-spin');
              }
          }).catch(function(err) {
            console.log(err);
            if (err.response.status == 0) {
                self.error = "Remote server can not be reachable";
            } else {
                //redirect to login page if user not authenticated
                if (err.response.status == 401) {
                    //clear previous data
                    localStorage.removeItem("user_obj");
                    localStorage.removeItem("api_token");
                    localStorage.removeItem("profile_image");
                    //EventBus.$emit("logged-in", true, "", "");
                    self.$router.push("/login");
                }
                self.error = err.response.data.message;
            }
          });
      },
  }
};
</script>
<style>
body {
  margin: 0;
  padding: 0;
  font-family: "SanFranciscoDisplayRegular" !important;
  background: #f5f5f5 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/CloseTicket.vue